import React from "react";
import "./Spinner.css";

const Spinner = () => <div className="Spinner" />;

export default Spinner;
